// The app's layout breakpoints, the one source of truth for every JS media query.
//
// Figma draws every phone composition at 320px, every tablet one at 768px and every desktop
// one at 1024px and up, so the phone/tablet switch is 768px and the tablet/desktop switch
// 1024px: a phone rule is `(max-width: 767px)`, a tablet-and-up rule `(min-width: 768px)`,
// a desktop rule `(min-width: 1024px)`, a tablet-and-below rule `(max-width: 1023px)`.
//
// CSS custom properties cannot be used inside an `@media` condition, so the CSS modules
// spell these numbers as literals that must mirror the constants here (tokens.css records
// them as --bp-* for reference). `breakpoints.css.spec.ts` fails when a retired phone/tablet
// literal (639, 640, 641) reappears in a stylesheet or a JS media query.

/** The narrowest width Figma draws the tablet compositions at. */
export const TABLET_MIN_WIDTH = 768;
/** The narrowest width Figma draws the desktop compositions at. */
export const DESKTOP_MIN_WIDTH = 1024;

/** Phones: below the tablet width (the header's mobile composition, bottom sheets). */
export const PHONE_MEDIA_QUERY = `(max-width: ${TABLET_MIN_WIDTH - 1}px)`;
/** Tablets and up. */
export const TABLET_UP_MEDIA_QUERY = `(min-width: ${TABLET_MIN_WIDTH}px)`;
/** Tablets and below: anything narrower than the desktop compositions. */
export const TABLET_DOWN_MEDIA_QUERY = `(max-width: ${DESKTOP_MIN_WIDTH - 1}px)`;
